<template>
  <v-dialog v-model="dialog" width="560" scrollable>
    <purchasing-action :lead="lead" @close="dialog = !dialog"></purchasing-action>
  </v-dialog>
</template>
<script>
import PurchasingAction from '@/modules/lead/bill/PurchasingAction.vue'
export default {
  components: { PurchasingAction },
  props: {
    lead: Object,
    state: Boolean
  },
  created () {},
  data () {
    return {
      dialog: false,
      tab: null
    }
  },
  computed: {},
  methods: {},
  filters: {},
  watch: {
    state (state) {
      this.dialog = true
    },
    lead () {
      console.log(this.lead)
    }
  }
}
</script>
